import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

const STATIC_TITLES = [
  { path: "/", title: "100ViewsOnly — Home", end: true },
  { path: "/welcome", title: "100ViewsOnly — Welcome" },
  { path: "/gallery", title: "100ViewsOnly — Gallery" },
  { path: "/discover", title: "100ViewsOnly — Gallery" },
  { path: "/featured", title: "100ViewsOnly — Featured" },
  { path: "/featured/discovery", title: "100ViewsOnly — Featured Discovery" },
  { path: "/featured/community", title: "100ViewsOnly — Featured Community" },
  { path: "/following", title: "100ViewsOnly — Following" },
  { path: "/search", title: "100ViewsOnly — Search" },
  { path: "/login", title: "Sign In — 100ViewsOnly" },
  { path: "/signup", title: "Sign Up — 100ViewsOnly" },
  { path: "/settings", title: "100ViewsOnly — Settings" },
  { path: "/notifications", title: "100ViewsOnly — Notifications" },
  { path: "/perks", title: "100ViewsOnly — Perks" },
  { path: "/themes", title: "100ViewsOnly — Theme Catalog" },
  { path: "/profile", title: "100ViewsOnly — Profile", end: true },
  { path: "/profile/edit", title: "100ViewsOnly — Edit Profile" },
  { path: "/dashboard", title: "100ViewsOnly — Dashboard" },
  { path: "/my-drops", title: "100ViewsOnly — My Drops" },
  { path: "/drops", title: "100ViewsOnly — My Drops" },
  { path: "/post", title: "100ViewsOnly — Post a Drop", end: true },
  { path: "/analytics", title: "100ViewsOnly — Analytics" },
  { path: "/earnings", title: "100ViewsOnly — Earnings" },
  { path: "/subscribers", title: "100ViewsOnly — Subscribers" },
  { path: "/broadcasts", title: "100ViewsOnly — Broadcasts" },
  { path: "/support-tiers", title: "100ViewsOnly — Support Tiers" },
  { path: "/appreciation-wall", title: "100ViewsOnly — Appreciation Wall" },
  { path: "/wall", title: "100ViewsOnly — Appreciation Wall" },
  { path: "/referral", title: "100ViewsOnly — Referrals" },
  { path: "/help", title: "100ViewsOnly — Help" },
  { path: "/legal", title: "100ViewsOnly — Legal" },
  { path: "/terms", title: "Terms of Service — 100ViewsOnly" },
  { path: "/privacy", title: "Privacy Policy — 100ViewsOnly" },
  { path: "/unsubscribe", title: "Email Preferences — 100ViewsOnly" },
  { path: "/waitlist/fan", title: "Fan Waitlist — 100ViewsOnly" },
  { path: "/waitlist/creator", title: "Creator Waitlist — 100ViewsOnly" },
  { path: "/become-creator", title: "Become a Creator — 100ViewsOnly" },
  { path: "/games", title: "100ViewsOnly — Games" },
  { path: "/pip-masters", title: "100ViewsOnly — Pip Masters" },
  { path: "/admin", title: "100ViewsOnly — Admin", end: false },
];

function titleForPathname(pathname) {
  for (const entry of STATIC_TITLES) {
    if (matchPath({ path: entry.path, end: entry.end !== false }, pathname)) {
      return entry.title;
    }
  }

  if (matchPath("/creator/:handle", pathname)) return "100ViewsOnly — Creator";
  if (matchPath("/creator/:handle/edit", pathname)) return "100ViewsOnly — Edit Creator Profile";
  if (matchPath("/drop/:id", pathname)) return "100ViewsOnly — Drop";
  if (matchPath("/post/:id", pathname)) return "100ViewsOnly — Post";
  if (matchPath("/fan/:userId", pathname)) return "100ViewsOnly — Fan Profile";
  if (matchPath("/user/:userId", pathname)) return "100ViewsOnly — Profile";
  if (matchPath("/profile/:username", pathname)) return "100ViewsOnly — Profile";
  if (pathname.startsWith("/admin")) return "100ViewsOnly — Admin";

  return "100ViewsOnly";
}

/** Sets document.title from the current route. Dynamic pages can override via setPageTitle(). */
export function setPageTitle(title) {
  if (!title) {
    document.title = "100ViewsOnly";
    return;
  }
  document.title = title.includes("100ViewsOnly") ? title : `${title} — 100ViewsOnly`;
}

export default function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = titleForPathname(pathname);
  }, [pathname]);

  return null;
}
